import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@shared/ui/breadcrumb';
import { useAuth } from '@shared/auth/AuthContext';
import { useActiveSuite } from '../useActiveSuite';
import { useCrumbs } from './useCrumbs';

export const AppBreadcrumbs: React.FC = () => {
  const crumbs = useCrumbs();
  const activeSuite = useActiveSuite();
  const { tenant } = useAuth();

  useEffect(() => {
    if (crumbs.length > 0) {
      const leafTitle = crumbs[crumbs.length - 1].label;
      const suiteName = activeSuite?.name ? ` · ${activeSuite.name}` : '';
      const orgName = tenant?.name ? ` · ${tenant.name}` : '';
      document.title = `${leafTitle}${suiteName}${orgName}`;
    }
  }, [crumbs, activeSuite, tenant]);

  if (crumbs.length === 0) return null;

  return (
    <Breadcrumb className="text-xs">
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <React.Fragment key={`${index}:${crumb.label}`}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {crumb.to && !isLast ? (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.to}>{crumb.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage className="font-semibold text-foreground">
                    {crumb.label}
                  </BreadcrumbPage>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
